/* Product specifications: preserve source values, compare by matching labels. */
(() => {
  const normalize = text => text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  const node = (tag, text, className) => {
    const el = document.createElement(tag);
    if (text !== undefined) el.textContent = text;
    if (className) el.className = className;
    return el;
  };
  function initPanel(panel) {
    if (panel.dataset.agSpecsReady) return;
    panel.dataset.agSpecsReady = 'true';
    panel.classList.add('ag-spec-system');
    panel.querySelectorAll('.metafield-rich_text_field').forEach(text => {
      const walker = document.createTreeWalker(text, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) walker.currentNode.textContent = walker.currentNode.textContent.replace(/\u00a0/g, ' ');
    });
    const buttonBox = panel.querySelector('.yg-switch-modal-button');
    const button = buttonBox?.querySelector('button');
    let expanded = false;
    let comparison;
    function refresh() {
      const wrappers = Array.from(panel.querySelectorAll('.yg-switch-modal-wrapper'));
      if (wrappers.length !== 2) return;
      const columns = wrappers.map(wrapper => {
        const text = wrapper.querySelector('.product-modal-text.active');
        if (!text) return null;
        const rows = Array.from(text.querySelectorAll('.metafield-rich_text_field > p'));
        const items = rows.map(p => {
          const label = p.querySelector(':scope > strong');
          const value = p.querySelector(':scope > span');
          return label && value ? {label: normalize(label.textContent), value: normalize(value.textContent)} : null;
        });
        if (!items.length || items.some(item => !item) || new Set(items.map(item => item.label.toLowerCase())).size !== items.length) return null;
        return {title: normalize(wrapper.querySelector('.yg-switch-modal-select button')?.textContent || ''), items};
      });
      if (columns.some(column => !column)) {
        comparison?.remove(); comparison = undefined;
        panel.classList.remove('ag-has-comparison');
        if (button) {buttonBox.hidden = false; button.textContent = button.dataset.more || 'Learn More';}
        return;
      }
      const maps = columns.map(column => new Map(column.items.map(item => [item.label.toLowerCase(), item])));
      const labels = [...new Set(maps.flatMap(map => Array.from(map.keys())))];
      const shared = [], different = [];
      labels.forEach(key => {
        const left = maps[0].get(key), right = maps[1].get(key);
        const row = {label: (left || right).label, values: [left?.value, right?.value]};
        if (left && right && left.value === right.value) shared.push(row);
        else different.push(row);
      });
      const content = node('div', undefined, 'ag-spec-comparison');
      const group = (title, rows, common) => {
        if (!rows.length) return;
        const region = node('section', undefined, common ? 'ag-spec-shared' : 'ag-spec-differences');
        region.append(node('h3', title));
        if (common) region.append(node('p', 'Same on both models.', 'ag-spec-note'));
        const table = node('table', undefined, 'ag-spec-table');
        table.append(node('caption', title + (common ? ' — ' + columns.map(c => c.title).join(' and ') : ''), 'ag-spec-caption'));
        if (!common) {
          const head = node('thead'), tr = node('tr');
          ["Specification", ...columns.map(column => column.title)].forEach(title => {
            const th = node('th', title); th.scope = 'col'; tr.append(th);
          });
          head.append(tr); table.append(head);
        }
        const body = node('tbody');
        rows.forEach((row, index) => {
          const tr = node('tr'); tr.dataset.specLabel = row.label;
          if (common && index >= 5 && !expanded && button) tr.hidden = true;
          const label = node('th', row.label); label.scope = 'row'; tr.append(label);
          (common ? [row.values[0]] : row.values).forEach((value, col) => {
            const td = node('td', value ?? '—');
            if (!common) td.dataset.model = columns[col].title;
            tr.append(td);
          });
          body.append(tr);
        });
        table.append(body); region.append(table);
        if (!common && rows.some(row => row.values.some(value => value === undefined))) region.append(node('p', '— indicates a specification not listed for that model.', 'ag-spec-note'));
        content.append(region);
      };
      group('Key differences', different, false);
      group('Shared specifications', shared, true);
      if (comparison) comparison.replaceWith(content);
      else panel.querySelector('.yg-switch-modal-container').after(content);
      comparison = content;
      panel.classList.add('ag-has-comparison');
      if (button) {
        buttonBox.hidden = shared.length <= 5;
        button.textContent = expanded ? (button.dataset.hide || 'Show Less') : 'View all shared specifications';
        button.setAttribute('aria-expanded', String(expanded));
      }
    }
    panel.addEventListener('click', event => {
      if (event.target.closest('.yg-switch-modal-button button') && panel.classList.contains('ag-has-comparison')) {
        event.preventDefault(); event.stopImmediatePropagation();
        expanded = !expanded; refresh();
        if (!expanded) comparison.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    }, true);
    panel.addEventListener('click', event => {
      if (event.target.closest('.yg-switch-accordion-item')) requestAnimationFrame(refresh);
    });
    refresh();
  }
  function init(root) {
    root.querySelectorAll('yg-switch-modal, [data-x2-comparison]').forEach(initPanel);
  }
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(() => init(document)));
  else requestAnimationFrame(() => init(document));
  document.addEventListener('shopify:section:load', event => requestAnimationFrame(() => init(event.target)));
})();
